import { useEffect, useState } from 'react';
import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2';

const PDP_SIDERAIL_URGENCY = 'pdpSiderailUrgency' as const;

export const usePdpSiderailUrgencyClientVariant = (): boolean | null => {
    const [isPdpSiderailUrgencyClientVariant, setPdpSiderailUrgencyClientVariant] = useState<
        boolean | null
    >(null);

    useEffect(() => {
        setPdpSiderailUrgencyClientVariant(
            getAbTestV2(PDP_SIDERAIL_URGENCY)?.variant === 'variant'
        );
    }, []);

    return isPdpSiderailUrgencyClientVariant;
};

export const trackPdpSiderailUrgencyClientVariant = (): void => {
    trackAbTestV2Variant(PDP_SIDERAIL_URGENCY);
};
